import React from "react";
import SpokePage from "./SpokePage";
import { EMPLOYER_STEPS } from "../../lib/adelContent";

import "../preview/Design13.css";
import "./Editorial.css";

/* Dedicated page: /employers/how-it-works — the simple 4-step client journey, each stage
   with a short explanation. Sells the outcome and the ease; the sourcing method stays
   behind the scenes (no screening/method language). */
export default function EmployerHowItWorksPage() {
  return (
    <SpokePage
      audience="employer"
      eyebrow="How it works"
      title={<>Simple, <em>from brief to arrival.</em></>}
      intro="From your first brief to your worker's arrival, we handle it — you review quality candidates and choose who's right for you. Here's how each stage works."
      next={{ label: "Why clients stay with Adel", to: "/employers/why-adel" }}
    >
      <section className="ed-band ed-band--cream ed-pad">
        <div className="ed-container">
          <ol className="ew-steps">
            {EMPLOYER_STEPS.map((s) => (
              <li key={s.n} className="ew-step">
                <span className="ew-step__n">{String(s.n).padStart(2, "0")}</span>
                <div className="ew-step__body">
                  <h3 className="ew-step__t">{s.t}</h3>
                  <p className="ew-step__b">{s.b}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </section>
    </SpokePage>
  );
}
